import React, { FunctionComponent, ReactElement, ElementType } from 'react'
import {
  observer
} from 'mobx-react'
import SchemerModel from '../../core/SchemerModel'
import {ARRAY} from '../../core/types/array'
import {MODEL} from '../../core/types/model'
import {NestedRow} from './NestedRow'
import { 
  DisplayFormatter,
  DisplayFormatterFn
} from '../../core/decorators/constants'
import {
  TextOverflow
} from 'react-base'

export interface CellValueProps {
  columnKey: string
  row: SchemerModel
  colWidth?: number
  value?: any
  valueType?: any
  // width: number
}

export const CellValue: FunctionComponent<CellValueProps> = observer(props => {
  const {
    columnKey,
    row,
    value,
    // width,
    valueType
  } = props
  const _value = value || row[columnKey]
  const _type = valueType || row.getType(columnKey)

  if (_value && _type === ARRAY) {
    const arrayOfType = row.getSubtype(columnKey)
    
    return (
      <div className={`sch_array`}>
        {_value.map((val: any, i: number) => {
          return (
            <CellValue
              key={i}
              row={row}
              columnKey={columnKey}
              value={val}
              // width={width}
              valueType={arrayOfType}      
            />
          )
        })}
      </div>
    )
  }
  else if (_value && _type === MODEL) {

    return (
      <NestedRow 
        isColHeader={false}
        // width={width}
        valueRaw={_value}
      />
    )
  }
  else {
    let contents: null|ReactElement|string = null
    let className: string = ''
    const formatter: DisplayFormatter = row.getFormatter(columnKey)

    if (formatter) {
      // if (isReactClassComponent(formatter)) {
      if (typeof formatter === 'object') {
        const FormatterCmp = formatter as ElementType
        contents = (
          <FormatterCmp
            value={_value}
            columnKey={columnKey}
            row={row}
          />
        )
        className = `formatter_cmp`
      }
      else if (typeof formatter === 'function') {
        const fmt = formatter as DisplayFormatterFn
        contents = fmt(_value)
        className = `formatter_fn`
      }
    }
    else {
      contents = _value
      className = `no_formatter`
    }

    if (contents) {
      if (typeof contents === 'string') {
        // TODO allow override
        contents = <TextOverflow>{contents}</TextOverflow>
      }
      return (
        <div className={`sch_cell_value ${className}`}>{contents instanceof Date ? contents.toString() : contents}</div>
      )
    }
    else {
      return null
    }
  }
})

CellValue.displayName = "Schemer.CellValue"
